// Website form submissions. Everything goes to the GrabNChat public
// lead-capture API (see lib/leadCapture.js) — there is no separate
// /api/leads or /api/newsletter endpoint on the backend.
import { captureLead } from "./leadCapture";

/**
 * "Book a demo" / contact-sales dialog. Company, website and team size are
 * folded into the lead's notes so the sales team sees them in the CRM.
 */
export const submitLead = ({ name, email, phone, company, website, employees, message, source, _gotcha }) => {
  const details = [
    company && `Company: ${company}`,
    website && `Website: ${website}`,
    employees && `Team size: ${employees}`,
    source && `Form: ${source}`,
    message && `\n${message}`,
  ]
    .filter(Boolean)
    .join("\n");
  return captureLead({
    name,
    email,
    phone,
    message: details,
    tags: ["website", "demo-request", source].filter(Boolean),
    _gotcha,
  });
};

/** Footer newsletter signup — saved as a lead tagged "newsletter". */
export const subscribeNewsletter = (email) => {
  const local = String(email || "").split("@")[0] || "Subscriber";
  return captureLead({
    name: `${local} (newsletter)`,
    email,
    message: "Subscribed to the GrabNChat newsletter from the website.",
    tags: ["website", "newsletter"],
  });
};
